const TABBABLE_NODES = /input|select|textarea|button|object/;
export const FOCUS_SELECTOR =
  'a, input, select, textarea, button, object, [tabindex]';

const getIsVisible = (element: HTMLElement) => {
  if (process.env.NODE_ENV === 'test') {
    return true;
  }

  return element.offsetWidth > 0 && element.offsetHeight > 0;
};

const getIsHidden = (element: HTMLElement) => {
  if (process.env.NODE_ENV === 'test') {
    return false;
  }
  const isVisible = getIsVisible(element);

  return element.style.display === 'none' || !isVisible;
};

const getElementTabIndex = (element: HTMLElement) => {
  let tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) {
    // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string | null'.
    tabIndex = undefined;
  }
  // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
  return parseInt(tabIndex, 10);
};

export const focusable = (element: HTMLElement) => {
  const nodeName = element.nodeName.toLowerCase();
  // @ts-expect-error - TS2339 - Property 'disabled' does not exist on type 'HTMLElement'.
  const isDisabled = element.disabled || element?.ariaDisabled === 'true';
  const isInert = Boolean(element?.inert);
  const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));

  const res =
    (TABBABLE_NODES.test(nodeName) && !isDisabled && !isInert) ||
    (element instanceof HTMLAnchorElement
      ? element.href || isTabIndexNotNaN
      : isTabIndexNotNaN);

  return res && !getIsHidden(element);
};

export const tabbable = (element: HTMLElement) => {
  const tabIndex = getElementTabIndex(element);
  const isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
};

export const findTabbableDescendants = (
  element: HTMLElement
): HTMLElement[] => {
  return Array.from(
    element.querySelectorAll<HTMLElement>(FOCUS_SELECTOR)
  ).filter(tabbable);
};
